import './radio-element.scss';

export default {
  form: '',
  fieldset: 'form-group',
  buttonLabel: 'label-override',
  buttonDetail: '',
  radioButton: 'radio-button',
  readOnly: 'radio-button radio-readonly',
  label: 'label-override',
  buttons: '',
  buttonsEmpty: '',
  buttonWrapper: '',
  requiredIndicator: 'required-indicator',
}
